<template>
  <div>
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div>
    </div>
    <div class="container">
      <Header />
      <div class="middlecontainer">
        <LeftMenu />
        <div class="middlerightcontainer">
          <router-view :isLoading="isLoading"></router-view>
        </div>
      </div>
  </div>
   
  </div>
</template>

<script>
import Header from './components/Header.vue';
import LeftMenu from './components/LeftMenu.vue';
export default {
  components: { Header, LeftMenu },
  inject: ['isLoading'],
  beforeMount() {
    if (this.isLoading && this.isLoading.value) {
      this.isLoading.value = false; // Ensure loading screen is hidden on component mount
    }
  }
}
</script>

<style>
.container {
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.middlecontainer {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.middlerightcontainer {
    display: flex;
    width: 100%;
    flex-direction: column;
    height: 100vh;
    overflow: scroll;
    background-color: #F8F8F8;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
